import Collection from "../../data-structures/collection"
import Resource from "./resource"


export default class ResourcesCollection extends Collection<Resource> {

    static initFromJson(data: JSONArray): ResourcesCollection {
        const collection = new ResourcesCollection([])
        _.map(data, (record: JSONObject) => collection.add(new Resource(record)))
        return collection
    }

    sort() {
        this.models = _.orderBy(this.models, [(m: Resource) => m.name?.toLowerCase()], ['asc'])
    }

    filterByCompany(companyId: ID): ResourcesCollection {
        const filtered = new ResourcesCollection(_.filter(this.models, (m: Resource) =>
            String(m.companyId) === String(companyId) && !m.isDeleted
        ))
        filtered.sort()
        return filtered
    }

    get notDeleted(): Resource[] {
        return _.filter(this.models, (r: Resource) => !r.isDeleted)
    }
}
